export type ProposalPayload = {
  companyName: string;
  companyAge: number; // idade da empresa em anos (ex.: 12 para "12 Anos" na p.4)
  contabilidadeTradicional: number;
  gestaoTributariaAcompanhamento: number;
  consultoriaMensal?: number;
};

export type CreateProposalResponse = {
  id: string;
  pdfSha256: string;
  downloadUrl: string;
};

export function formatBRL(value: number): string {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
}

/** URL da API em nuvem – usada sempre que o site NÃO está em localhost. */
const API_BASE_CLOUD = "https://ncc-proposta-api.ncc-92d.workers.dev";

/** Base URL da API. Em localhost usa "" (proxy Vite). Na nuvem usa sempre a API do Worker. */
export function getApiBase(): string {
  const base = (import.meta.env.VITE_API_BASE as string | undefined) ?? "";
  const trimmed = String(base).replace(/\/+$/, "").trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (typeof window !== "undefined" && /^localhost$|^127\.0\.0\.1$/i.test(window.location.hostname))
    return "";
  return API_BASE_CLOUD;
}

export async function createProposal(payload: ProposalPayload): Promise<CreateProposalResponse> {
  const normalized: Required<ProposalPayload> = {
    ...payload,
    companyAge: payload.companyAge ?? 0,
    consultoriaMensal: payload.consultoriaMensal ?? 0
  };
  const res = await fetch(`${getApiBase()}/api/proposals`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(normalized)
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Erro na API (${res.status}): ${text || "Falha ao gerar proposta"}`);
  }

  return (await res.json()) as CreateProposalResponse;
}

